/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_MenuInputs */

const en_nav_menu = /** @type {(inputs: Nav_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menu`)
};

const lv_nav_menu = /** @type {(inputs: Nav_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Izvēlne`)
};

/**
* | output |
* | --- |
* | "Menu" |
*
* @param {Nav_MenuInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const nav_menu = /** @type {((inputs?: Nav_MenuInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_MenuInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_nav_menu(inputs)
	return en_nav_menu(inputs)
});